/* @generated */
// prettier-ignore
export const calendars = ["buddhist","chinese","coptic","dangi","ethioaa","ethiopic","gregory","hebrew","indian","islamic","islamic-civil","islamic-rgsa","islamic-tbla","islamic-umalqura","islamicc","iso8601","japanese","persian","roc"] as const
export type Calendar = (typeof calendars)[number]
